export const isSupported = checkBrowserSupport();
function get(key) {
    if (hasError(key)) {
        return null;
    }
    try {
        let result = window.localStorage.getItem(key);
        return result !== null ? JSON.parse(result) : null;
    }
    catch (e) {
        return null;
    }
}
function set(key, value) {
    if (hasError(key) || !value) {
        return false;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
}
function hasError(key) {
    return !isSupported || !key;
}
function checkBrowserSupport() {
    let supported;
    try {
        supported = window.localStorage !== null;
        if (supported) {
            const key = '__testbrowsersupport';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
        }
        return supported;
    }
    catch (e) {
        supported = false;
    }
    return supported;
}
export const LocalStorageService = {
    get,
    set,
    isSupported
};
//# sourceMappingURL=local-storage-service.js.map